import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  BankAccountDto,
  CreateBankAccountRequest,
  UpdateBankAccountRequest,
} from '@/features/dashboard/paymentConfig/types/BankAccountDto.ts';

const bankAccountsApi = {
  getAll: async (): Promise<BankAccountDto[]> => {
    return await fetchPrivateApi<BankAccountDto[]>(
      'GET',
      'settings/payments/bank-accounts',
    );
  },
  create: async (dto: CreateBankAccountRequest): Promise<BankAccountDto> => {
    return await fetchPrivateApi<BankAccountDto>(
      'POST',
      'settings/payments/bank-accounts',
      dto,
    );
  },
  update: async (
    id: string,
    dto: UpdateBankAccountRequest,
  ): Promise<BankAccountDto> => {
    return await fetchPrivateApi<BankAccountDto>(
      'PUT',
      `settings/payments/bank-accounts/${id}`,
      dto,
    );
  },
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>(
      'DELETE',
      `settings/payments/bank-accounts/${id}`,
    );
  },
  setDefault: async (id: string): Promise<BankAccountDto> => {
    return await fetchPrivateApi<BankAccountDto>(
      'PUT',
      `settings/payments/bank-accounts/${id}/set-default`,
    );
  },
};

export default bankAccountsApi;
